// extracted by mini-css-extract-plugin
module.exports = {"actionWrap":"Action_actionWrap__24QG9","actionWrapStart":"Action_actionWrapStart__1GyNc","copyButton":"Action_copyButton__1GUEj"};